const actions = {
  SET_STATE: 'business/SET_STATE',
  UPDATE_WEBSITE_WIDGET: 'business/UPDATE_WEBSITE_WIDGET',
  GET_WEBSITE_WIDGET: 'business/GET_WEBSITE_WIDGET',
}

export default actions
